"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenFields = exports.withoutKeys = exports.withKeys = exports.allKeys = void 0;
/* tslint:disable */
/* eslint-disable */
function _mergeWithKeys(keys, objects) {
    if (keys === void 0) { keys = []; }
    if (objects.length === 0 || keys instanceof Array === false) {
        return {};
    }
    // only use objects for the merge, ignore null which is also typeof object
    objects = objects.filter(function (object) { return typeof object === 'object' && object; });
    var base = {};
    objects.forEach(function (object) {
        keys.forEach(function (key) {
            if (object.hasOwnProperty(key)) {
                base[key] = object[key];
            }
        });
    });
    return base;
}
function _mergeWithoutKeys(keys, objects) {
    if (keys === void 0) { keys = []; }
    if (objects.length === 0 || keys instanceof Array === false) {
        return {};
    }
    // only use objects for the merge, ignore null which is also typeof object
    objects = objects.filter(function (object) { return typeof object === 'object' && object; });
    // bracket notation lookup should be faster than repeated indexOf
    var omittedKeys = keys.reduce(function (holder, key) {
        holder[key] = true;
        return holder;
    }, {});
    var base = {};
    objects.forEach(function (object) {
        Object.keys(object).forEach(function (key) {
            if (omittedKeys[key] !== true) {
                base[key] = object[key];
            }
        });
    });
    return base;
}
function _validKeys(keys) {
    if (Array.isArray(keys)) {
        // only use strings as keys, and make sure they're unique
        return keys.filter(function (key, index, array) { return typeof key === 'string' && array.indexOf(key) === index && key.length > 0; });
    }
    return [];
}
function _flattenFields(refObject, delimiter, flattenArrays, newObject, prefix) {
    if (delimiter === void 0) { delimiter = '_'; }
    if (flattenArrays === void 0) { flattenArrays = false; }
    if (newObject === void 0) { newObject = {}; }
    var label;
    var currentItem;
    if (typeof delimiter !== 'string' || delimiter.length > 5) {
        delimiter = '_';
    }
    flattenArrays = Boolean(flattenArrays);
    if (typeof refObject === 'object' && refObject) {
        Object.keys(refObject).forEach(function (key) {
            label = prefix ? "".concat(prefix).concat(delimiter).concat(key) : key;
            currentItem = refObject[key];
            if (currentItem !== null &&
                ((typeof currentItem === 'object' && Object.keys(currentItem).length > 0) || Array.isArray(currentItem))) {
                if (Array.isArray(currentItem) && flattenArrays === false) {
                    newObject[label] = currentItem.concat();
                }
                else {
                    _flattenFields(currentItem, delimiter, flattenArrays, newObject, label);
                }
            }
            else {
                newObject[label] = currentItem;
            }
        });
    }
    return newObject;
}
// public exports
function allKeys() {
    return withoutKeys([]);
}
exports.allKeys = allKeys;
function withKeys(keys) {
    if (keys === void 0) { keys = []; }
    keys = _validKeys(keys);
    return {
        merge: function () {
            var objects = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                objects[_i] = arguments[_i];
            }
            return _mergeWithKeys(keys, objects);
        },
    };
}
exports.withKeys = withKeys;
function withoutKeys(keys) {
    if (keys === void 0) { keys = []; }
    keys = _validKeys(keys);
    return {
        merge: function () {
            var objects = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                objects[_i] = arguments[_i];
            }
            return _mergeWithoutKeys(keys, objects);
        },
    };
}
exports.withoutKeys = withoutKeys;
function flattenFields(refObject, delimiter, flattenArrays) {
    if (delimiter === void 0) { delimiter = '_'; }
    if (flattenArrays === void 0) { flattenArrays = false; }
    return _flattenFields(refObject, delimiter, flattenArrays, {}, '');
}
exports.flattenFields = flattenFields;
//# sourceMappingURL=merge.js.map